// extracted by mini-css-extract-plugin
export default {"container":"TableWithPagination_container__Dkzva","table":"TableWithPagination_table__xzkvn","paginationBottom":"TableWithPagination_paginationBottom__hzrgW"};